var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8062 10.0422H21.0007V10.0007H12.0007V14.0007H17.6522C16.8277 16.3292 14.6122 18.0007 12.0007 18.0007C8.68724 18.0007 6.00074 15.3142 6.00074 12.0007C6.00074 8.68717 8.68724 6.00067 12.0007 6.00067C13.5302 6.00067 14.9217 6.57767 15.9812 7.52017L18.8097 4.69167C17.0237 3.02717 14.6347 2.00067 12.0007 2.00067C6.47824 2.00067 2.00074 6.47817 2.00074 12.0007C2.00074 17.5232 6.47824 22.0007 12.0007 22.0007C17.5232 22.0007 22.0007 17.5232 22.0007 12.0007C22.0007 11.3302 21.9317 10.6757 21.8062 10.0422Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15311 7.34617L6.43861 9.75567C7.32761 7.55467 9.48061 6.00067 12.0001 6.00067C13.5296 6.00067 14.9211 6.57767 15.9806 7.52017L18.8091 4.69167C17.0231 3.02717 14.6341 2.00067 12.0001 2.00067C8.15911 2.00067 4.82811 4.16917 3.15311 7.34617Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 22.0006C14.5841 22.0006 16.9311 21.0121 18.7056 19.4046L15.6106 16.7856C14.5728 17.5748 13.3048 18.0017 12.0011 18.0006C9.40007 18.0006 7.19157 16.3421 6.35957 14.0276L3.09857 16.5401C4.75357 19.7786 8.11457 22.0006 12.0011 22.0006Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8058 10.042H21.0003V10.0005H12.0003V14.0005H17.6518C17.2574 15.1087 16.547 16.0771 15.6083 16.786L15.6098 16.785L18.7048 19.404C18.4858 19.603 22.0003 17.0005 22.0003 12.0005C22.0003 11.33 21.9313 10.6755 21.8058 10.042Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c400a5f1683d127fcdd2cc3df52dfb5b.svg";
export { ForwardRef as ReactComponent };